export default __webpack_public_path__ + "9cb2e5a0.woff2";